import { createAction } from '@reduxjs/toolkit';
import { TranslucentMessageType } from 'components/TranslucentMessage/TranslucentMessage.component';
import {
  SELF_EXCLUSION_COVERAGE,
  SELF_EXCLUSION_TYPE,
} from './selfExclusion.type';

export const selectExclusion = createAction<{
  exclusionCode: SELF_EXCLUSION_COVERAGE | '';
  mode?: 'add' | 'edit' | '';
}>('selfExclusion/SET_CUR_EXCLUSION');

export const setSelectedEditType = createAction<SELF_EXCLUSION_TYPE | ''>(
  'selfExclusion/SET_SELECTED_EDIT_TYPE',
);

export const openResponseFeedback = createAction<{
  type: TranslucentMessageType;
  coverage: SELF_EXCLUSION_COVERAGE | '';
}>('OPEN_RESPONSE_FEEDBACK');

export const closeResponseFeedback = createAction('CLOSE_RESPONSE_FEEDBACK');
